<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { inputFormReale } from './InputsFormReale';
import CertificatesRepository from '@repositories/certificates.repository';
import ConfigCertificatesRepository from '@repositories/configCertificates.repository';
import { IAssetsOption } from '../../types/optionsSelect.type';
import { ICurrencyOption } from '../../types/currency.type';
import { IAgenciesOption } from '../../types/agencies.type';
import CountriesRepository from '@repositories/countries.repository';
import { ICountry, ICountryOption } from '../../types/countries.type';
import { IBussinessUnitOption } from '../../types/businessUnit.type';
import { IConfigCertificate } from '../../types/configCertificate.type';
import { useToast } from '../../composables/useToast';
import AgenciesDataProviderRepository from '@repositories/agencies.repository';
import storeAuth from "@store/auth";
import { PERMISIION } from "../../helpers/dictionaryPermission";
import CompaniesRepository from '@repositories/companies.repository';
import { ICompany } from '../../types/company.type';
import LoadingIndicator from '@components/Loading/LoadingIndicator.vue';

const { $toast } = useToast();
const { t } = useI18n();

const { verifyPermission } = storeAuth()

const fieldsForm1 = ref(inputFormReale());
const refForm = ref<any>(null);
const assets = ref<IAssetsOption[]>([]);
const currencies = ref<ICurrencyOption[]>([]);
const agencies = ref<IAgenciesOption[]>([]);
const countries = ref<ICountryOption[]>([]);
const businessUnits = ref<IBussinessUnitOption[]>([]);
const isLoading = ref<boolean>(false);
const isLoadingForm = ref<boolean>(false);
const isShowModal = ref<boolean>(false);
const companies = ref<ICompany[]>([]);
const findCompanyId = ref<ICompany | null>(null);
const configCertificate = ref<IConfigCertificate | null>(null);
const formResetKey = ref<number>(0);


//API
const getAssets = async () => {
  try {
    const data = await CertificatesRepository.getAssets();

    if (data && Array.isArray(data)) {
      assets.value = data;
    }
    return [];
  } catch (error) {
    console.error('Error while fetching Assets:', error);
    return [];
  }
};
const getAgencies = async () => {
  try {
    const data = await AgenciesDataProviderRepository.getAllAgencies();

    if (data && Array.isArray(data)) {
      agencies.value = data
    }
    return [];
  } catch (error) {
    console.error('Error while fetching Assets:', error);
    return [];
  }
};
const getCurrencies = async () => {
  try {
    const data = await CertificatesRepository.getCurrencies();

    if (data && Array.isArray(data)) {
      currencies.value = data;
    }
    return [];
  } catch (error) {
    console.error('Error while fetching currencies:', error);
    return [];
  }
};
const getCountries = async () => {
  try {
    const { data } = await CountriesRepository.getcountries({ page: 0 });

    if (data.countries && Array.isArray(data.countries)) {
      countries.value = data.countries.map((country: ICountry) => ({
        id: country.id,
        nombre: country.description,
      }));
    }
    return [];
  } catch (error) {
    console.error('Error while fetching currencies:', error);
    return [];
  }
};
const getBusinessUnits = async () => {
  try {
    const data = await CertificatesRepository.getBusinessUnits();

    if (data && Array.isArray(data)) {
      businessUnits.value = data;
    }
    return [];
  } catch (error) {
    console.error('Error while fetching currencies:', error);
    return [];
  }
};
const getCompanies = async () => {
  const data = await CompaniesRepository.getCompanies();
  companies.value = data.companies;
};
const getConfigCertificate = async () => {
  findCompanyId.value = companies.value.find(company => company.name == 'Reale') ?? null
  if(!findCompanyId.value?.id) return

  const response = await ConfigCertificatesRepository.getConfigCerticatesByCompanyId(findCompanyId.value.id)
  if(!response?.id) return
  configCertificate.value = response

  const dateMin = new Date();
  dateMin.setDate(dateMin.getDate() - response.startDateMinTravel);

  fieldsForm1.value.forEach((field: any) => {
    if (field.key === 'dateOfIssue') {
      field.min = dateMin;
    }
    if (field.key === 'insuredValue') {
      field.placeholder = `Valor máximo de ${configCertificate.value?.maxValueAsset}`;
    }
  })
}

const updateFields = () => {
  fieldsForm1.value.forEach((field: any) => {
    if (field.key === 'assetId') {
      field.options = assets.value;
    }
    if (field.key === 'agencyId') {
      field.options = agencies.value;
    }
    if (field.key === 'currencyOfInsuredValueId') {
      field.options = currencies.value.filter(conutry => conutry.nombre !== "Dólar estadounidense (Siguiente día)");;
    }
    if (field.key === 'currencyTypeId') {
      field.options = currencies.value.filter(conutry => conutry.nombre !== "Dólar estadounidense (Siguiente día)");
    }
    const filteredCountries = countries.value
	.map(country => ({
		...country,
		nombre: country.nombre === "EEUU" ? "ESTADOS UNIDOS" : country.nombre
	}))
  .filter(country => country.nombre !== "MEXICO");
    if (field.key === 'countryOfOriginId') {
      field.options = filteredCountries;
    }
    if (field.key === 'countryOfDestinationId') {
      field.options = filteredCountries;
    }
    if (field.key === 'businessUnitId') {
      field.options = businessUnits.value;
    }
    if (field.key === 'currencyTypeId') {
      const currencyEuro = currencies.value.find((e) => e.nombre === 'Euro');
      field.value = currencyEuro;
    }
  });
};

const handleSelect = (e: any) => {
  if(e.input.key === 'typePolicyTransportId') {
    fieldsForm1.value.forEach((field: any) => {
      if (field.key === 'vessel') {
        field.hidden = e.value.nombre !== 'Maritimo';
      }
    });
  }
  if (e.input.key === 'assetId') {
    isShowModal.value = true
  }
  if (e.input.key === 'businessUnitId') {
    fieldsForm1.value.forEach((field: any) => {
      if (field.key === 'agencyId') {
        field.hidden = e.value?.nombre !== 'Altius S.A (España)';
        field.validations.rules.required = e.value?.nombre == 'Altius S.A (España)';
      }
    });
  }
};

onMounted(async () => {
  isLoadingForm.value = true;
  try {
    await getAssets();
    await getAgencies();
    await getCurrencies();
    await getCountries();
    await getBusinessUnits();
    await getCompanies();
    updateFields();

    if (verifyPermission(PERMISIION.SKIP_CERTIFICATE_CONFIG)) return;
    getConfigCertificate();
  } finally {
    isLoadingForm.value = false;
  }
});

const handleSubmit = async (e: any) => {

  if (!e.isFormValid) {
    $toast?.error(t('emision_de_cerificados.el_fomularios_es_invalido'));
    return;
  }

  if (configCertificate.value?.maxValueAsset && e.items.insuredValue > configCertificate.value?.maxValueAsset) {
    $toast?.error(t('emision_de_cerificados.error_valor_maximo') + configCertificate.value.maxValueAsset);
    return;
  }
  const cleanedData: Record<string, any> = e.items;
  cleanedData.companyId = configCertificate.value?.companyId
    ? configCertificate.value.companyId
    : companies.value.find(company => company.name == 'Reale')?.id ?? null

  try {
    isLoading.value = true;
    const data = await CertificatesRepository.createCertificate(cleanedData);

    if (data) {
      await resetForm();
      $toast?.success(
        t('emision_de_cerificados.el_certificado_se_ha_emitido_con_exito'),
      );
    }
  } catch (error) {
    $toast?.error(t('global.ocurrio_un_error'));
  } finally {
    isLoading.value = false;
  }
};

const handleClose = () => {
  isShowModal.value = false;
};

const resetForm = async () => {
  await refForm.value.resetValues();
  formResetKey.value++;
};
</script>

<template>
  <Layout
    :title="t('emision_de_cerificados.emision_de_cerificados')"
    :textColor="'color-secondary'"
  >
    <template #layout>
      <div v-if="isLoadingForm" class="form-loading">
        <LoadingIndicator />
      </div>
      <Form
	  	v-else
		ref="refForm"
		:key="formResetKey"
        :inputs="fieldsForm1"
        @onSubmit="handleSubmit"
        @select="handleSelect"
      >
        <template #buttons>
          <div class="d-flex">
            <CButton
              class="p-4 w-100 my-2 px-2"
              background="background-pink"
              style="font-size: 1rem"
            >
              <template #content>
                <div>
                  <BSpinner v-if="isLoading" />
                  <span v-else>{{
                    t('emision_de_cerificados.emitir_poliza')
                  }}</span>
                </div>
              </template>
            </CButton>
          </div>
        </template>
      </Form>
      <BModal
        :modelValue="isShowModal"
        hide-footer
        :centered="true"
        @hide="handleClose"
        static
        :title="t('emision_de_cerificados.listado_de_mercaderias_no_cubiertas')"
      >
        <ul>
          <li>Mercancía Excluida de Cobertura:</li>
          <li>Materias explosivas.</li>
          <li>Materias radioactivas.</li>
          <li>Animales y plantas vivas.</li>
          <li>Prensa en cualquiera de sus variedades.</li>
          <li>Tabaco.</li>
          <li>Efectos personales, mudanzas, equipajes y herramientas propias.</li>
          <li>Pieles finas, confeccionadas o sin confeccionar.</li>
          <li>Mercancías a granel en bodega.</li>
          <li>Transportes funerarios.</li>
          <li>Cobre, níquel y aleaciones de estos metales en cualquier formato.</li>
          <li>Metálico, efectos comerciales o bancarios.</li>
          <li>Títulos y cupones de valores mobiliarios.</li>
          <li>Billetes de banco.</li>
          <li>Lotería y quinielas premiadas.</li>
          <li>Alhajas y artículos de joyería, de metales finos.</li>
          <li>Piedras preciosas y perlas verdaderas.</li>
          <li>Orfebrería de metales finos.</li>
          <li>Objetos de arte, antiguos o raros cuyo valor fuera convencional.</li>
          <li>Colecciones.</li>
          <li>Timbres o efectos timbrados.</li>
          <li>Metales preciosos.</li>
          <li>Baterías de Litio y vehículos eléctricos: A CONSULTAR CONDICIONES.</li>
          <li>Project Cargo: A CONSULTAR CONDICIONES.</li>
        </ul>
      </BModal>
    </template>
  </Layout>
</template>

<style scoped>
.form-loading {
  display: flex;
  justify-content: center;
  padding-top: 3.5rem;
}
</style>
